import React from 'react'
import { ReturnCard } from '../shared/sso-workspace/return-card'
import { ForgetAccountOffer } from '../shared/recent-accounts/forget-account'

// Where the identity provider returns the browser after the desktop, VR or
// mobile app signs out with "end the identity provider session" on. The app
// opened the provider's sign-out in the system browser, so this is a tab the
// user never meant to use -- the same outcome card as OpenComplete's "you're
// signed in, return to the app" (return-card.js, variant signedOut).
//
// Recent accounts (owner 2026-10-25): when this browser remembers accounts
// for the sign-in page, the card offers to forget them here
// (ForgetAccountOffer: the page can't tell which account signed out).
export const OpenSignedOut = () =>
  <ReturnCard
    variant="signedOut"
    id="signed-out-title"
    title="You're signed out"
    lede="You're signed out of EducationXR and your identity provider."
    hint="You can close this window and return to the app.">
    <ForgetAccountOffer />
  </ReturnCard>
